/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2022-12-20 21:24:41
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React from 'react';
import tipAlert from '../../Login/BsyAlertTip/Staticize';
import { BsyUtils } from '../../utils/Utils';
import BsyDeptPane from '../BsyDeptPane';
import BsyDialog from '../BsyDialog';

import { BsyWidget } from '../BsyWidget';
import './index.css'
import BsySLoading from "../BsySLoading";

export default class BsyDeptJobtitleSelectPane extends BsyWidget {

  constructor(props) {
    super({

      onStopEdit: null,
      ...props
    });
    this.valueMap = {};
    this.nameMap = {};

    this.state = {
      ...this.state,
      jobtitles: [],
      selectDept: null,
      departments: [...props.departments],
      value: this.value2data(props.jobtitles),
      jobtitlePermission: true, //当前成员是否在指定部门
      inDepts: this.dept2inDepts(props.departments),
      isload: true,
    }
    this.deptmap = {};
    let that = this;
    BsyUtils.forEach(this.state.departments, (a, b) => {
      that.deptmap[b.id] = b;
    })
    this.batchText = React.createRef();
  }

  dept2inDepts = (departments) => {
    let res = BsyUtils._getSeachUserDeptListArray(departments, 'corp');
    return res
  }

  componentDidMount() {
    if (this.state.inDepts.length) {

      this.depter = this.state.inDepts[0];
      this.getJobTitleList(this.state.inDepts[0])
    }
  }

  value2data = (jobtitles) => {
    let val = [];
    for (let index = 0; index < jobtitles.length; index++) {
      const element = jobtitles[index];
      this.valueMap[`${element._id}-${element.job}`] = element;
      this.nameMap[`${element._id}-${element.job}`] = `${element.nickname}-${element.job}`;
      val.push(`${element._id}-${element.job}`)
    }
    return val;
  }

  getJobTitleList(dept) {

    // if (!this.deptmap[dept.departmentId]) {
    //     this.setState({
    //         selectDept: dept._id,
    //         jobtitlePermission: false,
    //         jobtitles: [],
    //     })
    //     return
    // }
    React.axios('/corp/department/all_job_title', {
      // deptId: dept.deptId,
      mode: 'current',
      _id: dept._id,
    }).then(res1 => {
      const items = res1.data.list.map(data => {
        return data.value;
      })
      this.setState({
        selectDept: dept._id,
        jobtitlePermission: true,
        jobtitles: items
      })
    }).catch(res => {
      this.setState({
        jobtitlePermission: true,
        selectDept: dept._id,
        jobtitles: [],
      })
    })
  }

  removeMap = (data) => {
    let { value } = this.state;
    if (this.valueMap[data]) {
      delete this.valueMap[data]
    }
    if (this.nameMap[data]) {
      delete this.nameMap[data]
    }
    let i = value.indexOf(data);
    if (i > -1) {
      value.splice(i, 1);
    }
    this.setState({
      value: value
    }, () => {
      this.onStopEdit()
    })
  }

  hasValue = (data) => {
    const { value, selectDept } = this.state
    return value.indexOf(`${selectDept}-${data}`) > -1
  }

  addValue = (data) => {
    const { value, selectDept } = this.state;
    let val = value.filter((data) => {
      return data.indexOf(selectDept) === -1
    })
    let element = {
      id: this.depter.departmentId,
      _id: this.depter._id,
      nickname: this.depter.title,
      job: data,
    }
    this.valueMap[`${element._id}-${element.job}`] = element;
    this.nameMap[`${element._id}-${element.job}`] = `${element.nickname}-${element.job}`;
    value.push(`${element._id}-${element.job}`)
    this.setState({
      value: value,
    }, () => {
      this.onStopEdit()
    })
  }

  getNumberValue = () => {
    const { value } = this.state;
    let obj = [];
    for (let index = 0; index < value.length; index++) {
      const element = this.valueMap[value[index]];
      if (element) {
        let v = {};
        v[element.id] = element.job;
        obj.push(v)
      }
    }
    return [...obj]
  }
  get_idValue = () => {
    const { value } = this.state;
    let obj = [];
    for (let index = 0; index < value.length; index++) {
      const element = this.valueMap[value[index]];
      obj.push(element)
    }
    return [...obj]
  }

  onStopEdit = () => {
    this.props.onStopEdit && this.props.onStopEdit(this.getNumberValue(), this.get_idValue())
  }

  extractText = (inputString) => {
    const regex = /[\u4e00-\u9fa5a-zA-Z0-9]+/g;
    const matches = inputString.match(regex);

    if (matches) {
      return matches.join('');
    } else {
      return '';
    }
  }

  addJobtitle = (e) => {
    const { jobtitles } = this.state;
    let adds = [];
    let repeats = [];
    let maxLength = [];
    BsyDialog({
      title: React.language("address.book.dept.jobtitle.addnew"),
      height: 470,
      width: 450,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        setTimeout(() => {
          this.batchText.current && this.batchText.current.focus();
        }, 30)
        return <div className="add-jobtitle-name">
          <div className="add-jobtitle-tip">*{React.language("address.book.dept.jobtitle.addnew.tip")}</div>
          <textarea
            ref={this.batchText}
            style={{ height: 290, lineHeight: "20px", marginTop: 12 }}
            onKeyUp={e => {
              adds = [];
              repeats = [];
              maxLength = []
              let val = e.target.value;
              let ds = val.split('\n');
              for (let index = 0; index < ds.length; index++) {
                let element = this.extractText(ds[index].trim()) + "";
                if (element) {
                  element += "";

                  if (jobtitles.indexOf(element) === -1) {
                    if (element.length > 16) {
                      maxLength.push(element)
                    } else {
                      adds.push(element.trim())
                    }
                  } else {
                    repeats.push(element)
                  }
                }
              }
            }}
          >

          </textarea>
        </div>
      },
      onOk: () => {
        if (maxLength.length) {
          tipAlert({
            type: 'warning',
            msg: React.language('position.add.tip1', { name: maxLength.join('、'), max: 16 })
          })
          return false
        }
        if (repeats.length) {
          tipAlert({
            type: 'warning',
            msg: React.language('position.add.tip2', { name: repeats.join('、') })
          })
          return false
        }
        this.setState({
          jobtitles: [...jobtitles, ...adds]
        }, () => {

          React.axios('/corp/department/job_title_sort', {
            "items": this.state.jobtitles
          }).then(res1 => {

          }).catch(res => {

          })

        })
      }
    })
  }

  render() {
    const { value, jobtitles, selectDept, jobtitlePermission, inDepts, isload } = this.state
    return <div className="bsy-dept-jobtitle-select"
      ref={this.element}
    >
      {isload && <BsySLoading style={{ background: "#fff" }} />}
      <ul className='select-list'>
        {
          value ? value.map((data) => {
            if (!this.nameMap[data]) {
              return ''
            }

            return <li className={'select-item'}><i className={'icon-bsy-jobtitle'}></i> {this.nameMap[data]} <span
              className="remove-btn" onClick={e => {
                this.removeMap(data)
              }}><i className="icon-close-large"></i></span></li>
          }) : ""
        }
      </ul>
      <div className='select-pane'>
        <div className='dept-pane'>
          <div className="dept-title">{React.language("user.in.dept")}</div>
          <ul>
            {
              inDepts.map((data) => {
                return <li className={'dept-item ' + (data._id === selectDept ? 'select' : '')} title={data.moreTitle}
                  onClick={e => {
                    this.depter = data;
                    this.getJobTitleList(data)
                  }}
                >{data.moreTitle}</li>
              })
            }
          </ul>
          <div className="dept-title">{React.language("all.dept")}</div>
          <BsyDeptPane
            value={selectDept}
            onStopEdit={(e, t) => {
              if (t) {
                this.setState({ isload: false }, () => {
                  if (inDepts.length > 0) {
                    this.depter = inDepts[0]
                    this.getJobTitleList(inDepts[0])
                  }
                })
              } else {
                this.depter = e;
                this.getJobTitleList(e)
              }
            }}
          >
          </BsyDeptPane>
        </div>
        <div className='dept-jobtitle-pane'>
          {
            jobtitlePermission ? <>
              <div className='dept-jobtitle-pane-inner'>
                <ul>
                  {
                    jobtitles.map((data, index) => {

                      if (this.hasValue(data)) {
                        this.selectJobtitle = data;
                      }
                      return <li onClick={e => {

                        if (e.currentTarget.classList.contains('select')) {
                          this.removeMap(`${selectDept}-${data}`)
                        } else {
                          this.addValue(data)
                        }
                      }}
                        className={'job-title-list-li ' + (this.hasValue(data) ? 'select' : '')}><i
                          className="icon-bsy-check2"></i>{data}

                      </li>
                    })
                  }
                </ul>
              </div>
              {

                <div className={'add-jobtitle'}
                  onClick={this.addJobtitle}>{React.language('address.book.dept.jobtitle.add')}</div>
              }

            </> :
              <div className={'no-permission'}>{React.language('address.book.dept.jobtitle.addnew.no-permission')}</div>
          }

        </div>
      </div>
    </div>
  }

}
